export default "__VITE_ASSET__CCEg8hNe__"